import { getUrlQuery } from '@/common/utils';
import { fetchDcepCommonConfig } from './horn';
import { post } from './ajax';
import { env } from './env';
import { monitor } from './monitor';
import { bridge } from './bridge';
import {
  dandanleActivityId, lotteryActivityId, cashbackActivityId, cashbackUpgradeId, cashbackOpenWalletId
} from './config';
import { getLocation } from './utils';

class Api {
  test(params: any): Promise<any> {
    return post('/api/test', params);
  }
  getAiLink(activityName: string) {
    return post('/dcep/activity/queryCustomerServiceUrl', {
      activity_name: activityName
    }).then((res) => {
      const aiLink = (res && res.customer_service_url) || '';
      return aiLink;
    }).catch((err) => { throw err; });
  }
  async getAndroidDcepAppDownloadUrl() {
    try {
      const config = await fetchDcepCommonConfig();
      if (!config) return '';
      const urlObj = config.downloadUrl;
      if (!urlObj) return '';
      return urlObj.androidUrl;
    } catch (err) {
      console.log(err);
      return '';
    }
  }
  async participate(payType: string, activityName: string) {
    try {
      const data = {
        pay_type: payType,
        activity_name: activityName
      };
      const commonParams = env.commonParams;
      let location = commonParams.location;
      if (location === '0_0') {
        const l: any = await bridge.getLocation();
        const { lat, lng } = l;
        if (Number(lat) === 0 || Number(lng) === 0) {
          monitor.captureMessage({
            name: '【买菜活动-报名接口获取定位异常】',
            msg: `${lat}_${lng}`
          }, {
            level: 'warn'
          });
        }
        location = `${lat}_${lng}`;
      }
      const from = env.from;
      const _commonParams = {
        nb_platform: commonParams.platform,
        nb_appversion: commonParams.version,
        nb_app: commonParams.app,
        nb_location: location,
        nb_uuid: commonParams.uuid,
        nb_fingerprint: commonParams.fingerprint,
        from
      };
      return post('/dcep/activity/participate', Object.assign(_commonParams, data)).then((res) => res).catch((err) => { throw err; });
    } catch (err) {
      monitor.captureMessage({
        name: '【低碳活动-participate接口异常】',
        msg: JSON.stringify(err)
      }, {
        level: 'warn'
      });
      return {};
    }
  }
  async queryParticipateResult(activityName: string, location: string) {
    try {
      const data = {
        activity_name: activityName,
        nb_location: location
      };
      const commonParams = env.commonParams;
      const from = env.from;
      const _commonParams = {
        nb_platform: commonParams.platform,
        nb_appversion: commonParams.version,
        nb_app: commonParams.app,
        nb_uuid: commonParams.uuid,
        nb_fingerprint: commonParams.fingerprint,
        nb_ci: commonParams.cityId,
        from
      };
      monitor.captureMessage({
        name: '【queryParticipateResult】',
        msg: `activity_name:${activityName};href:${window.location.href}`
      }, {
        level: 'warn'
      });
      if (window.location.href && window.location.href.includes('openFromEcny')) {
        monitor.captureMessage({
          name: '【queryParticipateResult-openFromEcny】',
          msg: `activity_name:${activityName};href:${window.location.href}`
        }, {
          level: 'warn'
        });
      }
      return post('/dcep/activity/queryParticipateResult', Object.assign(_commonParams, data)).then((res) => res).catch((err) => { throw err; });
    } catch (err) {
      monitor.captureMessage({
        name: '【低碳活动-queryParticipateResult】',
        msg: JSON.stringify(err)
      }, {
        level: 'warn'
      });
      return {};
    }
  }
  async queryActivityGroupParticipateResult(activityGroupId: string, location: string) {
    try {
      const data = {
        activity_group_id: activityGroupId,
        nb_location: location
      };
      const commonParams = env.commonParams;
      const from = env.from;
      const _commonParams = {
        nb_platform: commonParams.platform,
        nb_appversion: commonParams.version,
        nb_app: commonParams.app,
        nb_uuid: commonParams.uuid,
        nb_fingerprint: commonParams.fingerprint,
        nb_ci: commonParams.cityId,
        from
      };
      monitor.captureMessage({
        name: '【queryActivityGroupParticipateResult】',
        msg: `activity_group_id:${activityGroupId};href:${window.location.href}`
      }, {
        level: 'warn'
      });
      return post('/dcep/activity/queryActivityGroupParticipateResult', Object.assign(_commonParams, data)).then((res) => res).catch((err) => { throw err; });
    } catch (err) {
      monitor.captureMessage({
        name: '【低碳活动-queryActivityGroupParticipateResult',
        msg: JSON.stringify(err)
      }, {
        level: 'warn'
      });
      return {};
    }
  }
  async queryReverseBindWalletInfo(params: Object) {
    try {
      return post('/ecny/wallet/user/queryReverseBindWalletInfo', params).then((res) => res).catch((err) => { throw err; });
    } catch (err) {
      monitor.captureMessage({
        name: '/ecny/wallet/user/queryReverseBindWalletInfo',
        msg: JSON.stringify(err)
      }, {
        level: 'warn'
      });
      return {};
    }
  }
  async dealReverseBindWalletRespInfo(sign: any, signInfo: any) {
    try {
      return post('/ecny/wallet/user/dealReverseBindWalletRespInfo', {
        sign,
        signInfo
      }).then((res) => res).catch((err) => { throw err; });
    } catch (err) {
      monitor.captureMessage({
        name: '/ecny/wallet/user/dealReverseBindWalletRespInfo',
        msg: JSON.stringify(err)
      }, {
        level: 'warn'
      });
      return {};
    }
  }
  async queryGuidePage(params: Object) {
    try {
      const from = env.from;
      const commonParams = {
        nb_platform: env.commonParams.platform,
        from
      };
      return post('/dcep/activity/guidepage', Object.assign(commonParams, params)).then((res) => res).catch((err) => { throw err; });
    } catch (err) {
      monitor.captureMessage({
        name: '/dcep/activity/guidepage',
        msg: JSON.stringify(err)
      }, {
        level: 'warn'
      });
      return {};
    }
  }
  async queryActivityGroupParticipateResultV2(activityGroupId: string, location: string) {
    try {
      const data = {
        activityGroupId,
        nb_location: location
      };
      const commonParams = env.commonParams;
      const from = env.from;
      const _commonParams = {
        nb_platform: commonParams.platform,
        nb_appversion: commonParams.version,
        nb_app: commonParams.app,
        nb_uuid: commonParams.uuid,
        nb_fingerprint: commonParams.fingerprint,
        nb_ci: commonParams.cityId,
        from
      };
      return post('/dcep/activity/v2/queryActivityGroupParticipateResult', Object.assign(_commonParams, data)).then((res) => res).catch((err) => { throw err; });
    } catch (err) {
      monitor.captureMessage({
        name: '【活动二期-queryActivityGroupParticipateResult',
        msg: JSON.stringify(err)
      }, {
        level: 'warn'
      });
      return {};
    }
  }
  async participateV2(payType: string, activityId: string) {
    try {
      const data = {
        payType,
        activityId
      };
      const commonParams = env.commonParams;
      let location = commonParams.location;
      if (location === '0_0' || location === '0.0_0.0') {
        const l: any = await bridge.getLocation();
        const { lat, lng } = l;
        if (Number(lat) === 0 || Number(lng) === 0) {
          monitor.captureMessage({
            name: '【活动二期-报名接口获取定位异常】',
            msg: `${lat}_${lng}`
          }, {
            level: 'warn'
          });
        }
        location = `${lat}_${lng}`;
      }
      const from = env.from;
      const _commonParams = {
        nb_platform: commonParams.platform,
        nb_appversion: commonParams.version,
        nb_app: commonParams.app,
        nb_location: location,
        nb_uuid: commonParams.uuid,
        nb_fingerprint: commonParams.fingerprint,
        from
      };
      return post('/dcep/activity/v2/participate', Object.assign(_commonParams, data)).then((res) => res).catch((err) => { throw err; });
    } catch (err) {
      monitor.captureMessage({
        name: '【活动二期-participate接口异常】',
        msg: JSON.stringify(err)
      }, {
        level: 'warn'
      });
      return {};
    }
  }
  async queryGuidePageV2(params: Object) {
    try {
      const from = env.from;
      const commonParams = {
        nb_platform: env.commonParams.platform,
        from
      };
      return post('/dcep/activity/v2/guidepage', Object.assign(commonParams, params)).then((res) => res).catch((err) => { throw err; });
    } catch (err) {
      monitor.captureMessage({
        name: '/dcep/activity/v2/guidepage',
        msg: JSON.stringify(err)
      }, {
        level: 'warn'
      });
      return {};
    }
  }
  async applyAndGuidePage(params: Object) {
    try {
      const commonParams = env.commonParams;
      let location;
      try {
        location = await getLocation();
      } catch (err) {
        location = '';
      }
      const from = env.from;
      const _commonParams = {
        nb_platform: commonParams.platform,
        nb_appversion: commonParams.version,
        nb_app: commonParams.app,
        nb_uuid: commonParams.uuid,
        nb_fingerprint: commonParams.fingerprint,
        nb_ci: commonParams.cityId,
        nb_location: location,
        from
      };
      return post('/dcep/activity/v2/applyAndGuidePage', Object.assign(_commonParams, params)).then((res) => res).catch((err) => { throw err; });
    } catch (err) {
      monitor.captureMessage({
        name: '建行钱包升级applyAndGuidePage接口异常',
        msg: JSON.stringify(err)
      }, {
        level: 'warn'
      });
      return {};
    }
  }

  async getPullEcnyAppUpgradeWalletParams(sourceApplication: string, appId: string, pullAbbrName: string, payType: string, upgradeType: number) {
    try {
      const params = {
        sourceApplication,
        appId,
        pullAbbrName,
        payType,
        upgradeType
      };
      return post('/ecny/walletapp/user/getPullEcnyAppUpgradeWalletParams', params).then((res) => res).catch((err) => { throw err; });
    } catch (err) {
      monitor.captureMessage({
        name: '钱包升级getPullEcnyAppUpgradeWalletParams接口异常',
        msg: JSON.stringify(err)
      }, {
        level: 'warn'
      });
      return null;
    }
  }
  async getPullEcnyAppUpgradeWalletResult(signInfo: string, sign: string, extraInfo: string, biz: string, version: number) {
    try {
      const params = {
        signInfo,
        sign,
        extraInfo,
        biz,
        version
      };
      return post('/ecny/walletapp/user/getPullEcnyAppUpgradeWalletResult', params).then((res) => res).catch((err) => { throw err; });
    } catch (err) {
      monitor.captureMessage({
        name: '钱包升级getPullEcnyAppUpgradeWalletResult接口异常',
        msg: JSON.stringify(err)
      }, {
        level: 'warn'
      });
      return null;
    }
  }

  /**
   * 单单乐首页查询接口
   */
  async queryOrderRewardActivityHome() {
    try {
      const params = {
        activityId: env.actGroupName || dandanleActivityId
      };
      return post('/dcep/activity/ddl/queryOrderRewardActivityHome', params).then((res) => res).catch((err) => { throw err; });
    } catch (err) {
      monitor.captureMessage({
        name: '【单单乐】queryOrderRewardActivityHome',
        msg: JSON.stringify(err)
      }, {
        level: 'error'
      });
      return {};
    }
  }

  /**
   * 奖励记录
   */
  async queryOrderRewardDetail(params: Object) {
    try {
      const data = {
        activityId: env.actGroupName || dandanleActivityId,
        ...params
      };
      return post('/dcep/activity/ddl/queryOrderRewardDetail', data, { showToast: false }).then((res) => res).catch((err) => { throw err; });
    } catch (err) {
      monitor.captureMessage({
        name: '【单单乐】queryOrderRewardDetail',
        msg: JSON.stringify(err)
      }, {
        level: 'error'
      });
      return {};
    }
  }

  /**
   * 完成约定
   */
  async finishApply(bankTypeId: number) {
    try {
      const location = await getLocation();
      const commonParams = env.commonParams;
      const params = {
        activityId: env.actGroupName || dandanleActivityId,
        bankTypeId,
        nb_uuid: commonParams.uuid,
        nb_fingerprint: commonParams.fingerprint,
        nb_platform: commonParams.platform,
        nb_location: location
      };
      return post('/dcep/activity/ddl/finishApply', params).then((res) => res).catch((err) => { throw err; });
    } catch (err) {
      monitor.captureMessage({
        name: '【单单乐】finishApply',
        msg: JSON.stringify(err)
      }, {
        level: 'error'
      });
      return {};
    }
  }
  /**
   * 一键报名
   */
  async preApply() {
    try {
      const location = await getLocation();
      const commonParams = env.commonParams;
      const params = {
        activityId: env.actGroupName || dandanleActivityId,
        nb_uuid: commonParams.uuid,
        nb_fingerprint: commonParams.fingerprint,
        nb_platform: commonParams.platform,
        nb_location: location,
        from: env.from
      };
      return post('/dcep/activity/ddl/preApply', params).then((res) => res).catch((err) => { throw err; });
    } catch (err) {
      monitor.captureMessage({
        name: '【单单乐】preApply',
        msg: JSON.stringify(err)
      }, {
        level: 'error'
      });
      return {};
    }
  }

  /**
   * 修改银行接口
   */
  async updateApplyBank(bankTypeId: number) {
    try {
      const location = await getLocation();
      const commonParams = env.commonParams;
      const params = {
        activityId: env.actGroupName || dandanleActivityId,
        bankTypeId,
        nb_uuid: commonParams.uuid,
        nb_fingerprint: commonParams.fingerprint,
        nb_platform: commonParams.platform,
        nb_location: location,
        from: env.from
      };
      return post('/dcep/activity/ddl/updateApplyBank', params).then((res) => res).catch((err) => { throw err; });
    } catch (err) {
      monitor.captureMessage({
        name: '【单单乐】updateApplyBank',
        msg: JSON.stringify(err)
      }, {
        level: 'error'
      });
      return {};
    }
  }

  /**
   * 历史榜单查询
   */
  async queryHistoryByDate(rewardDate: string) {
    try {
      const params = {
        rewardDate,
        activityId: env.actGroupName || dandanleActivityId,
      };
      return post('/dcep/activity/ddl/queryHistoryByDate', params).then((res) => res).catch((err) => { throw err; });
    } catch (err) {
      monitor.captureMessage({
        name: '【单单乐】queryHistoryByDate',
        msg: JSON.stringify(err)
      }, {
        level: 'error'
      });
      return {};
    }
  }

  /**
   * 好彩头首页查询
   */
  async queryHctActivityHome(location: any) {
    try {
      const params = {
        activityId: env.actGroupName || lotteryActivityId,
        nb_location: location,
        from: env.from
      };
      return post('/ecny/activity/hct/queryHctActivityHome', params).then((res) => res).catch((err) => {
        throw err;
      });
    } catch (err) {
      monitor.captureMessage({
        name: '【好彩头】queryHctActivityHome',
        msg: JSON.stringify(err)
      }, {
        level: 'error'
      });
      return {};
    }
  }

  /**
   * 好彩头活动分享
   */
  async shareHctActivity() {
    try {
      const params = {
        activityId: env.actGroupName || lotteryActivityId,
        from: env.from
      };
      return post('/ecny/activity/hct/shareHctActivity', params).then((res) => res).catch((err) => {
        throw err;
      });
    } catch (err) {
      monitor.captureMessage({
        name: '【好彩头】shareHctActivity',
        msg: JSON.stringify(err)
      }, {
        level: 'error'
      });
      return {};
    }
  }

  /**
   * 好彩头抽奖接口
   */
  async drawLottery() {
    try {
      const location = await getLocation();
      const commonParams = env.commonParams;
      const params = {
        activityId: env.actGroupName || lotteryActivityId,
        nb_location: location,
        from: env.from,
        nb_platform: commonParams.platform,
        nb_appversion: commonParams.version,
        nb_app: commonParams.app,
        nb_uuid: commonParams.uuid,
        nb_fingerprint: commonParams.fingerprint
      };
      return post('/ecny/activity/hct/drawLottery', params).then((res) => res).catch((err) => {
        throw err;
      });
    } catch (err) {
      monitor.captureMessage({
        name: '【好彩头】drawLottery',
        msg: JSON.stringify(err)
      }, {
        level: 'error'
      });
      return {};
    }
  }

  /**
   * 好彩头去佩戴头像
   */
  async querySignInfo(params: any) {
    return post('/ecny/activity/hct/querySignInfo', params).then((res) => res).catch((err) => {
      throw err;
    });
  }

  /**
   * 数币返现
   */
  async queryCashbackHome() {
    // 不强依赖定位
    const commonParams = env.commonParams;
    let location = commonParams.location;
    if (location === '0_0') {
      try {
        const l: any = await bridge.getLocation();
        const { lat, lng } = l;
        location = `${lat}_${lng}`;
      } catch (err) { location = '0_0'; }
    }
    const params = {
      activityGroupId: env.actGroupName || cashbackActivityId,
      insId: getUrlQuery().insId || '',
      nb_uuid: commonParams.uuid,
      nb_fingerprint: commonParams.fingerprint,
      nb_platform: commonParams.platform,
      nb_location: location,
      from: env.from
    };
    return post('/ecny/task/cashback/home', params, { showToast: false }).then((res) => res).catch((err) => {
      throw err;
    });
  }

  /**
   * 我的返现钱包
   */
  async queryWallet() {
    const commonParams = env.commonParams;
    const params = {
      activityGroupId: env.actGroupName || cashbackActivityId,
      insId: getUrlQuery().insId || '',
      nb_uuid: commonParams.uuid,
      nb_fingerprint: commonParams.fingerprint,
      nb_platform: commonParams.platform,
      from: env.from
    };
    return post('/ecny/task/cashback/wallet', params, { showToast: false }).then((res) => res).catch((err) => {
      throw err;
    });
  }

  /**
   * 查询累计中金额
   */
  async queryAccumulate() {
    const commonParams = env.commonParams;
    const params = {
      activityGroupId: env.actGroupName || cashbackActivityId,
      insId: getUrlQuery().insId || '',
      nb_uuid: commonParams.uuid,
      nb_fingerprint: commonParams.fingerprint,
      nb_platform: commonParams.platform,
      from: env.from
    };
    return post('/ecny/task/cashback/accumulate', params, { showToast: false }).then((res) => res).catch((err) => {
      throw err;
    });
  }

  /**
   * 发起提现
   */
  async withdraw(data: any) {
    // 不强依赖定位
    const commonParams = env.commonParams;
    let location = commonParams.location;
    if (location === '0_0') {
      try {
        const l: any = await bridge.getLocation();
        const { lat, lng } = l;
        location = `${lat}_${lng}`;
      } catch (err) { location = '0_0'; }
    }
    const params = {
      activityGroupId: env.actGroupName || cashbackActivityId,
      insId: getUrlQuery().insId || '',
      nb_uuid: commonParams.uuid,
      nb_fingerprint: commonParams.fingerprint,
      nb_platform: commonParams.platform,
      from: env.from,
      ...data
    };
    return post('/ecny/task/cashback/withdraw', params, { showToast: false }).then((res) => res).catch((err) => {
      throw err;
    });
  }

  /**
   * 查询营销
   */
  async queryMarketing(data: any) {
    // 不强依赖定位
    const commonParams = env.commonParams;
    const params = {
      activityGroupId: env.actGroupName || cashbackActivityId,
      insId: getUrlQuery().insId || '',
      nb_uuid: commonParams.uuid,
      nb_fingerprint: commonParams.fingerprint,
      nb_platform: commonParams.platform,
      from: env.from,
      ...data
    };
    return post('/ecny/task/cashback/marketing', params, { showToast: false }).then((res) => res).catch((err) => {
      throw err;
    });
  }

  /**
   * 提现结果查询
   */
  async queryWithdrawResult(data: any) {
    const params = {
      activityId: env.actGroupName || cashbackActivityId,
      from: env.from,
      ...data
    };
    return post('/ecny/activity/cashback/queryWithdrawResultV2', params, { showToast: false }).then((res) => res).catch((err) => {
      throw err;
    });
  }

  /**
   * 订阅或取消订阅接口
   */
  async subscribeToggle(data: any) {
    const commonParams = env.commonParams;
    const params = {
      activityGroupId: env.actGroupName || cashbackActivityId,
      insId: getUrlQuery().insId || '',
      nb_uuid: commonParams.uuid,
      nb_fingerprint: commonParams.fingerprint,
      nb_platform: commonParams.platform,
      from: env.from,
      ...data
    };
    return post('/ecny/task/cashback/subscribe', params, { showToast: false }).then((res) => res).catch((err) => {
      throw err;
    });
  }

  /**
   * 查询返现明细接口
   */
  async cashbackRecord() {
    const commonParams = env.commonParams;
    const params = {
      activityGroupId: env.actGroupName || cashbackActivityId,
      insId: getUrlQuery().insId || '',
      nb_uuid: commonParams.uuid,
      nb_fingerprint: commonParams.fingerprint,
      nb_platform: commonParams.platform,
      from: env.from,
    };
    return post('/ecny/task/cashback/cashbackRecord', params).then((res) => res).catch((err) => {
      throw err;
    });
  }

  /**
   * 查询提现明细接口
   */
  async withdrawRecord(data: any) {
    const commonParams = env.commonParams;
    const params = {
      activityGroupId: env.actGroupName || cashbackActivityId,
      insId: getUrlQuery().insId || '',
      nb_uuid: commonParams.uuid,
      nb_fingerprint: commonParams.fingerprint,
      nb_platform: commonParams.platform,
      from: env.from,
      ...data
    };
    return post('/ecny/task/cashback/withdrawRecord', params).then((res) => res).catch((err) => {
      throw err;
    });
  }

  /**
   * 返现失效记录
   */
  async expireRecord() {
    const commonParams = env.commonParams;
    const params = {
      activityGroupId: env.actGroupName || cashbackActivityId,
      insId: getUrlQuery().insId || '',
      nb_uuid: commonParams.uuid,
      nb_fingerprint: commonParams.fingerprint,
      nb_platform: commonParams.platform,
      from: env.from
    };
    return post('/ecny/task/cashback/expireRecord', params).then((res) => res).catch((err) => {
      throw err;
    });
  }

  /**
   * 返现加倍结果接口
   */
  async cashbackExpandResult() {
    const urlQuery = getUrlQuery();
    const activityGroupIds = urlQuery && urlQuery.activityGroupIds;
    const commonParams = env.commonParams;
    const params = {
      activityGroupIds,
      activityId: env.actGroupName || cashbackActivityId,
      from: env.from,
      nb_uuid: commonParams.uuid,
      nb_fingerprint: commonParams.fingerprint,
      nb_platform: commonParams.platform,
      nb_appversion: commonParams.version,
      nb_app: commonParams.app,
    };
    return post('/ecny/activity/cashback/cashbackExpandResult', params).then((res) => res).catch((err) => {
      throw err;
    });
  }

  /**
   * 查看2023服贸会token接口
   */
  async token() {
    const params = {};
    return post('/ecny/activity/servicetrade/token', params, { showToast: false }).then((res) => res).catch((err) => {
      throw err;
    });
  }

  /**
   * 首页接口
   */
  async servicetraceHome(params: any) {
    return post('/ecny/activity/servicetrade/home', params, { showToast: false }).then((res) => res).catch((err) => {
      throw err;
    });
  }

  /**
   * 查询首页红包信息
   */
  async getRedPacketAmount(params: any) {
    return post('/ecny/zone/v3/marketingAssets/getRedPacketAmount', params, { showToast: false }).then((res) => res).catch((err) => {
      throw err;
    });
  }

  /**
   * 查询首页红包信息
   */
  async getCouponTotal(params: any) {
    return post('/ecny/zone/v3/marketingAssets/getCouponTotal', params, { showToast: false }).then((res) => res).catch((err) => {
      throw err;
    });
  }

  /**
   * 2023服贸会打开
   */
  async scan(params: any) {
    return post('/ecny/activity/servicetrade/scan', params, { showToast: false }).then((res) => res).catch((err) => {
      throw err;
    });
  }

  /**
   * 查询无权益活动信息
   */
  async getNewUserBank(params: any) {
    return post('/ecny/walletapp/user/getNewUserBank', params, { showToast: false, showError: false }).then((res) => res).catch((err) => {
      throw err;
    });
  }

  /**
   * @doc https://km.sankuai.com/collabpage/2249854307#id-5.4.%E9%A6%96%E9%A1%B5%EF%BC%88%E5%8F%8C%E7%AB%AF%E8%BF%94%E7%8E%B0%EF%BC%89
   * @decs 双端返现首页接口
   * @returns AjaxResponse
   */
  async doubleEndHome() {
    const bocParams = await bridge.getBocDeviceInfo();
    let params = {
      activityGroupId: getUrlQuery()?.actGroupName || cashbackActivityId,
      insId: getUrlQuery().insId || '',
      from: env.from,
    };
    params = Object.assign(params, bocParams);
    return post('/ecny/task/cashback/doubleEndHome', params, { showToast: false, showError: true }).then((res) => res).catch((err) => {
      throw err;
    });
  }

  /**
   * @decs 双端返现查询当前绑定状态
   * @returns AjaxResponse
   */
  async getBindWalletList() {
    let params = {
      insId: 10005,
      walletType: 1,
      filterByLoginMobile: true,
      uniqueInsId: true,
    };
    params = Object.assign(params);
    return post('/ecny/wallet/user/getBindWalletList', params, { showToast: false, showError: true }).then((res) => res).catch((err) => {
      throw err;
    });
  }

  /**
   * @doc https://km.sankuai.com/collabpage/2249854307#id-5.6.%E8%90%A5%E9%94%80%E5%8D%A1%E7%89%87%EF%BC%88%E5%8F%8C%E7%AB%AF%E8%BF%94%E7%8E%B0%EF%BC%89
   * @desc 双端返现营销卡片接口
   * @returns AjaxResponse
   */
  async doubleEndMarketing() {
    const bocParams = await bridge.getBocDeviceInfo();
    let params = {
      upgradeActivityGroupId: getUrlQuery()?.cashbackUpgradeId || cashbackUpgradeId,
      bindActivityGroupId: getUrlQuery()?.cashbackOpenWalletId || cashbackOpenWalletId,
      activityGroupId: getUrlQuery()?.actGroupName || cashbackActivityId,
      insId: getUrlQuery().insId || '10005',
      from: env.from
    };
    params = Object.assign(params, bocParams);
    return post('/ecny/activity/doubleEndMarketing', params, { showToast: false, showError: true }).then((res) => res).catch((err) => {
      throw err;
    });
  }
  /**
   * @doc https://km.sankuai.com/collabpage/2249854307#id-5.5.%E9%A2%86%E5%8F%96%EF%BC%88%E5%8F%8C%E7%AB%AF%E8%BF%94%E7%8E%B0%EF%BC%89
   * @desc 双端返现领取接口
   * @returns AjaxResponse
   */
  async doubleEndWithdraw() {
    const bocParams = await bridge.getBocDeviceInfo();
    let params = {
      activityGroupId: getUrlQuery()?.actGroupName || cashbackActivityId,
      insId: getUrlQuery().insId || '10005',
      from: env.from
    };
    params = Object.assign(params, bocParams);
    return post('/ecny/task/cashback/doubleEndWithdraw', params, { showToast: false, showError: true }).then((res) => res).catch((err) => {
      throw err;
    });
  }
}

export const api = new Api();
